module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-tabbed-charging-sessions-list"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('base-list', {
    ref: "chargingSessionsBaseList",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "showPerPageSelect": false,
      "component-type": _vm.reservation !== null ? 'reservation' : 'listing'
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-778a3d0e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/ChargingSessionsList.vue
// module id = 2598
// module chunks = 1